import { LocationTableObject } from './location-object.model';
import { ContactObject } from './location-contacts-table/contact-object.model';
import { AddressesObject } from './locations-address-table/addresses-object.model';
import { AddressObject } from './locations-address-table/address-object-model';

export class LocationObject {

    constructor(private table: LocationTableObject, private contacts: Array<ContactObject>, private addresses: Array<AddressObject>) {

    }

    public static create() {
        return new LocationObject(LocationTableObject.create(), new Array<ContactObject>(), new Array<AddressObject>());
    }

    public getLocationsTable(): LocationTableObject {
        return this.table;
    }

    public getContacts(): Array<ContactObject> {
        return this.contacts;
    }

    public getAddresses(): Array<AddressObject> {
        return this.addresses;
    }

}